import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-devices-breadcrumb-filter-card',
  templateUrl: './devices-breadcrumb-filter-card.component.html',
  styleUrls: ['./devices-breadcrumb-filter-card.component.scss']
})
export class DevicesBreadcrumbFilterCardComponent implements OnInit {

  @Input() devices;
  centers;
  types;
  models;
  statuses;
  licenses;
  centersForm = new FormGroup({});
  typesForm = new FormGroup({});
  modelsForm = new FormGroup({});
  statusesForm = new FormGroup({});
  licensesForm = new FormGroup({});

  constructor(private devicesService: DevicesDevicesService,
              private userStorageService: UserStorageService) { }

  ngOnInit() {
    this.getCenters();
    this.getTypes();
    this.getModels();
    this.getStatuses();
    this.getLicenses();
    if (this.userStorageService.getFilterDevices()) {
      this.centersForm.patchValue(this.userStorageService.getFilterDevices()['centersForm']);
      this.typesForm.patchValue(this.userStorageService.getFilterDevices()['typesForm']);
      this.modelsForm.patchValue(this.userStorageService.getFilterDevices()['modelsForm']);
      this.statusesForm.patchValue(this.userStorageService.getFilterDevices()['statusesForm']);
      this.licensesForm.patchValue(this.userStorageService.getFilterDevices()['licensesForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterDevices({
      centersForm: this.centersForm.getRawValue(),
      typesForm: this.typesForm.getRawValue(),
      modelsForm: this.modelsForm.getRawValue(),
      statusesForm: this.statusesForm.getRawValue(),
      licensesForm: this.licensesForm.getRawValue()
    });
    if (this.userStorageService.getFilterDevices()['centersForm']['all'] &&
      this.userStorageService.getFilterDevices()['typesForm']['all'] &&
      this.userStorageService.getFilterDevices()['modelsForm']['all'] &&
      this.userStorageService.getFilterDevices()['statusesForm']['all'] &&
      this.userStorageService.getFilterDevices()['licensesForm']['all']) {
      this.userStorageService.deleteFilterDevices();
    }
    this.filter();
  }

  private getCenters() {
    const centers = new Array<string>();
    this.centersForm.addControl('all', new FormControl(true));
    this.devices.forEach((d: DeviceBasic) => {
      if (centers.indexOf(d.CenterName) === -1) {
        centers.push(d.CenterName);
        this.centersForm.addControl(d.CenterName, new FormControl(false));
      }
    });
    this.centers = centers;
  }

  private getTypes() {
    const types = new Array<string>();
    this.typesForm.addControl('all', new FormControl(true));
    this.devices.forEach((d: DeviceBasic) => {
      if (types.indexOf(d.DeviceTypeName) === -1) {
        types.push(d.DeviceTypeName);
        this.typesForm.addControl(d.DeviceTypeName, new FormControl(false));
      }
    });
    this.types = types;
  }

  private getModels() {
    const models = new Array<string>();
    this.modelsForm.addControl('all', new FormControl(true));
    this.devices.forEach((d: DeviceBasic) => {
      if (models.indexOf(d.DeviceModel) === -1) {
        models.push(d.DeviceModel);
        this.modelsForm.addControl(d.DeviceModel, new FormControl(false));
      }
    });
    this.models = models;
  }

  private getStatuses() {
    const statuses = new Array<string>();
    this.statusesForm.addControl('all', new FormControl(true));
    this.devices.forEach((d: DeviceBasic) => {
      if (statuses.indexOf(d.Status) === -1) {
        statuses.push(d.Status);
        this.statusesForm.addControl(d.Status, new FormControl(false));
      }
    });
    this.statuses = statuses;
  }

  private getLicenses() {
    const licenses = new Array<string>();
    this.licensesForm.addControl('all', new FormControl(true));
    this.devices.forEach((d: DeviceBasic) => {
      if (licenses.indexOf(d.LicenseDescription) === -1) {
        licenses.push(d.LicenseDescription);
        this.licensesForm.addControl(d.LicenseDescription, new FormControl(false));
      }
    });
    this.licenses = licenses;
  }

  public filter() {
    const forms = {
      centersForm:
      {
        attribute: 'CenterName',
        values: []
      },
      typesForm:
      {
        attribute: 'DeviceTypeName',
        values: []
      },
      modelsForm:
      {
        attribute: 'DeviceModel',
        values: []
      },
      statusesForm:
      {
        attribute: 'Status',
        values: []
      },
      licensesForm:
      {
        attribute: 'LicenseDescription',
        values: []
      }
    };
    if (this.centersForm.get('all').value) {
      forms['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
    } else {
      Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { forms['centersForm'].values.push(c[0]); }});
    }
    if (this.typesForm.get('all').value) {
      forms['typesForm'].values = Object.keys(this.typesForm.value).splice(1);
    } else {
      Object.entries(this.typesForm.value).map(c => { if (c[1]) { forms['typesForm'].values.push(c[0]); }});
    }
    if (this.modelsForm.get('all').value) {
      forms['modelsForm'].values = Object.keys(this.modelsForm.value).splice(1);
    } else {
      Object.entries(this.modelsForm.value).map(c => { if (c[1]) { forms['modelsForm'].values.push(c[0]); }});
    }
    if (this.statusesForm.get('all').value) {
      forms['statusesForm'].values = Object.keys(this.statusesForm.value).splice(1);
    } else {
      Object.entries(this.statusesForm.value).map(c => { if (c[1]) { forms['statusesForm'].values.push(c[0]); }});
    }
    if (this.licensesForm.get('all').value) {
      forms['licensesForm'].values = Object.keys(this.licensesForm.value).splice(1);
    } else {
      Object.entries(this.licensesForm.value).map(c => { if (c[1]) { forms['licensesForm'].values.push(c[0]); }});
    }
    this.devicesService.filterDevices(forms);
  }
}
